import React, {InputHTMLAttributes} from 'react'
import styled from 'styled-components'
import {Box, StyleProps} from '@miro-site/core'
import inputStyles from './Input.style'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  type: InputHTMLAttributes<HTMLInputElement>['type']
  name: InputHTMLAttributes<HTMLInputElement>['name']
  required?: InputHTMLAttributes<HTMLInputElement>['required']
  error?: string
  icon?: React.ReactNode
  iconStyles?: StyleProps
  loader?: boolean
  isError?: boolean
}

const Container = styled(Box).attrs({
  $styles: {
    ...inputStyles.container,
  },
})``

const Wrapper = styled(Box).attrs({
  $styles: {
    ...inputStyles.wrapper,
  },
})``

const Field = styled(Box).attrs<InputProps>(({theme, isError}) => ({
  as: 'input',
  $styles: {
    ...inputStyles.field,
    borderColor: isError ? theme.colors.bold : theme.colors.dimmedGray,
  },
}))<InputProps>``

const Icon = styled(Box).attrs(({$styles}) => ({
  $styles: {
    ...inputStyles.icon,
    ...$styles,
  },
}))``

const Error = styled(Box).attrs({
  $styles: {
    ...inputStyles.error,
  },
})``

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (props: InputProps, ref): React.ReactElement => {
    const {name, error, required, loader, icon, iconStyles, ...rest} = props

    return (
      <Container>
        <Wrapper>
          {icon && (
            <Icon $styles={iconStyles} data-testid="input-icon">
              {icon}
            </Icon>
          )}
          <Field
            ref={ref}
            name={name}
            aria-required={!!required}
            required={!!required}
            aria-invalid={!!error}
            disabled={loader}
            isError={!!error}
            {...rest}
          />
        </Wrapper>

        {error && <Error>{error}</Error>}
      </Container>
    )
  },
)

Input.displayName = 'Input'

export default Input
